/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gb: NonNullable<unknown> }} Embed_Captions_Pricing_Storage_HelpInputs */



/**
* | output |
* | --- |
* | "{gb} GB • 14 days hosting • Download allowance" |
*
* @param {Embed_Captions_Pricing_Storage_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_storage_help = /** @type {((inputs: Embed_Captions_Pricing_Storage_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Storage_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.gb} Go • hebergement 14 jours • allocation de telechargement`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 Tage Hosting • Download-Limit`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 giorni di hosting • Limite di download`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.gb} ГБ • 14 дней хостинга • Лимит на скачивание`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 días de alojamiento • Permiso de descarga`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 天主机托管 • 下载限额`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.gb} GB • 14日間のホスティング • ダウンロード許容量`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 दिनों की होस्टिंग • डाउनलोड की अनुमति`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.gb} GB • Hospedagem por 14 dias • Limite de download`)
	return /** @type {LocalizedString} */ (`${i?.gb} GB • 14 days hosting • Download allowance`)
});